// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"4bea51c3","455":"c360b846","977":"4b21a000"}[chunkId] + ".chunk.js";
};